import { useApplicationContext } from '../../context/ApplicationContext/ApplicationContext';

export const useStorefrontPathname = () => {
  const { state } = useApplicationContext();
  const slug = state.user?.store?.slug;

  return slug ? `/${slug}` : null;
};
